import './ProductCard.css'
import { useProductCard } from '../shared/useProductCard'
import {
  FlyToCartBubbles,
  ProductDetailScreen,
  VariantPickerPortal,
} from '../shared/ProductCardPortals'

function ProductCard({ product, onAddToCart, cartCount = 0 }) {
  const card = useProductCard(product, { onAddToCart, cartCount })
  const {
    coverImage,
    currentPrice,
    oldPrice,
    pricePrefix,
    priceSuffix,
    isAnimating,
    handleAddClick,
    detailOpen,
    openDetail,
  } = card

  return (
    <div className="product-card">
      <button
        type="button"
        className="product-image-container product-image-trigger"
        onClick={openDetail}
        aria-haspopup="dialog"
        aria-expanded={detailOpen}
        aria-label={`Подробнее: ${product.name ?? 'товар'}`}
      >
        <img
          src={coverImage}
          alt=""
          className="product-image"
        />
        <div className="image-gradient-overlay" aria-hidden="true" />
      </button>
      <div className="product-info">
        <button
          type="button"
          className="product-name product-name-trigger"
          onClick={openDetail}
          aria-haspopup="dialog"
          aria-expanded={detailOpen}
        >
          {product.name}
        </button>
        <div className="product-price-container">
          <div className="product-prices">
            {oldPrice != null && (
              <span className="product-price-old" aria-label="Прежняя цена">
                {oldPrice.toFixed(2)} сом
              </span>
            )}
            <span className="product-price">
              {Number.isFinite(currentPrice)
                ? `${pricePrefix}${currentPrice.toFixed(2)} сом${priceSuffix || ''}`
                : '—'}
            </span>
          </div>
          <button
            className={`add-button ${isAnimating ? 'animating' : ''}`}
            onClick={handleAddClick}
            aria-label="Add to cart"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 4V16M4 10H16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>
      <ProductDetailScreen skin="regular" card={card} />
      <VariantPickerPortal card={card} />
      <FlyToCartBubbles items={card.flyItems} />
    </div>
  )
}

export default ProductCard
